export default __webpack_public_path__ + "static/media/add-note.26b4495f.svg";